// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const PrimaryProductStatuses = t.list(KeyValuePair, 'PrimaryProductStatuses');

export const getDefaultState = () => [getKeyValuePairDefaultState()];

export default PrimaryProductStatuses;



// WEBPACK FOOTER //
// ./src/product/status-change-request/state/primary-product-statuses.js